// componente utilizzato per chiamare i dati verso l'esterno da next.js 
// al server dati

import { API_ENDPOINT } from "./Constants";


const ApiCall = async (path, body) => {
  try{
    const response = 
      await fetch(
        `${API_ENDPOINT.BASE_URL}/${path}`,
        {
          method: "POST",
          body
        }
      );
    if(response){

      const json = await response.json();
      if(json){
        return json;    
      }else{
        console.log(json.code, json.message, json.status); 
      }
    }

  } catch (error) {
    console.log(error)
  }
  
  return null;
}

export {ApiCall};